import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import { ICompanyNameAndCVRInputModel } from "../components/form/company/CompanyNameAndCVRInput"
import { endpointsShared } from "../data/endpointsShared"
import { kycActions } from "../store/kycSlice"
import { SharedStoreState } from "../store/SharedStoreState"
import { swMerchantActions, swMerchantSelectors } from "../store/swMerchantSlice"
import { IUpdateKycFlowRequest, IUpdateKycFlowResponse } from "../types/kyc/kycFlowTypes"
import { IMerchantAcquiringKyc } from "../types/merchant/IMerchantAcquiring"
import { TOrganizationType } from "../types/organization/TOrganizationType"
import { requestThunk } from "./serverThunks"

export const getMerchantAcquiringThunk =
    (swMerchantId: string, force: boolean): ThunkAction<void, SharedStoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        if (!force && swMerchantSelectors.acquiringKycs(getState(), swMerchantId)) {
            return
        }
        const res = await dispatch(
            requestThunk<{ acquiringKycs: IMerchantAcquiringKyc[] }>(endpointsShared.Identity.getMerchantAcquiring, {
                params: {
                    swMerchantId,
                },
            })
        )
        dispatch(
            swMerchantActions.setAcquiringKycs({
                swMerchantId,
                acquiringKycs: res.acquiringKycs,
            })
        )
    }

export const setMerchantAcquiringThunk =
    (
        acquiringKyc: IMerchantAcquiringKyc,
        company: ICompanyNameAndCVRInputModel,
        ignoreWebshopIds: boolean
    ): ThunkAction<void, SharedStoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        await Promise.all([
            dispatch(
                requestThunk<{ acquiringKycs: IMerchantAcquiringKyc[] }>(endpointsShared.Identity.setMerchantAcquiring, {
                    data: {
                        ignoreWebshopIds,
                        acquiringKyc,
                    },
                })
            ),
            dispatch(setMerchantAcquiringInKycApiThunk(acquiringKyc, company)),
        ])
        await dispatch(getMerchantAcquiringThunk(acquiringKyc.swMerchantId, true))
    }

export const setMerchantAcquiringInKycApiThunk =
    (kyc: IMerchantAcquiringKyc, company: ICompanyNameAndCVRInputModel): ThunkAction<void, SharedStoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        const resp = await dispatch(
            requestThunk<IUpdateKycFlowResponse>(endpointsShared.KYC.updateFlow, {
                data: {
                    organizationId: kyc.swMerchantId,
                    organizationType: TOrganizationType.SwMerchant,
                    webshopId: kyc.webshopIds[0],
                    flowType: "Preonboarding",
                    eventType: "Initiated",
                    organization: {
                        orgVatNumber: company.companyNumber,
                        orgName: company.companyName,
                        orgAddress: company.companyAddress,
                        orgCity: company.companyCity,
                        orgPostCode: company.companyPostcode,
                        orgCountryCode: company.country,
                    },
                    webshop: {
                        avgTransactionAmount: kyc.avgTransactionAmount,
                        businessDescription: kyc.businessDescription,
                        currencies: [kyc.currency],
                        delayComment: kyc.delayComment,
                        deliveryDelay: kyc.deliveryDelay,
                        isSellingPhysicalProducts: kyc.isSellingPhysicalProducts,
                        isSellingSubscriptions: kyc.isSellingSubscriptions,
                        isUsingDropShipping: kyc.isUsingDropShipping,
                        tradeName: kyc.tradeName,
                        turnoverMonthly: kyc.turnoverMonthly,
                    },
                } satisfies IUpdateKycFlowRequest,
            })
        )
        dispatch(kycActions.orgDetails({ organizationId: kyc.swMerchantId, details: resp.organization }))
        dispatch(kycActions.webshopDetails({ webshopId: kyc.webshopIds[0], details: resp.webshop }))
        dispatch(kycActions.setFlows({ organizationId: kyc.swMerchantId, flows: resp.flows }))
    }